import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import FaStar from 'react-icons/lib/fa/star'
import cx from 'classnames'

const styles = () => ({
  root: {
    display: 'inline-block',
    color: '#dbc70d',
    '& > svg': {
      position: 'relative',
      top: -1,
    },
  },
  star: {
    position: 'relative',
    top: -1,
  },
})

const Featured = ({
  classes,
  doubleStar,
  variant,
  noIndent,
  className,
  starClassName,
  color,
  icon,
  iconColor,
  style,
  children,
  ...props
}) => (
  <Typography
    className={cx(classes.root, className)}
    variant={variant || 'caption'}
    style={{ color, ...style }}
    {...props}
  >
    {noIndent ? null : <Fragment>&nbsp;</Fragment>}
    {icon ? (
      <Fragment>
        {icon} {children || 'Featured'} {doubleStar && icon}
      </Fragment>
    ) : (
      <Fragment>
        <FaStar
          className={cx(classes.star, starClassName)}
          style={{ color: iconColor }}
        />{' '}
        {children || 'Featured'}
        {doubleStar && (
          <Fragment>
            {' '}
            <FaStar
              className={cx(classes.star, starClassName)}
              style={{ color: iconColor }}
            />
          </Fragment>
        )}
      </Fragment>
    )}
  </Typography>
)

Featured.propTypes = {
  classes: PropTypes.object.isRequired,
  variant: PropTypes.string,
  noIndent: PropTypes.bool,
  className: PropTypes.string,
  starClassName: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.any,
  iconColor: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.any,
}

export default withStyles(styles)(Featured)



// WEBPACK FOOTER //
// ./src/components/Featured.js